<template>

  <div class="p-4 space-y-4  ">
    <!-- Título sección -->
    <div class="flex justify-between">
      <span  class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">&#60;CentroCuentasMayorCero&#62;</span>

    </div>


 


    <div v-if="centro" class="flex items-center justify-between px-6 py-4 mb-5 rounded-2xl shadow-md" :class="borrador
      ? 'bg-gradient-to-r from-green-800 to-emerald-200 text-white'
      : 'bg-gradient-to-r from-indigo-800 to-blue-200 text-white'">
      <h2 class="text-lg font-semibold tracking-wide font-mono">
        {{ centro?.nombre }} {{ aa_consulta }}

      </h2>
    </div>





    <div class="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden">

      <!-- Header -->
      <TablaTotalesCentro v-if="!prop_categoria_id" :borrador="borrador" :centro_id="centro_id" :date_time="date_time"
        :prop_incluyeCero="incluyeCero" />

    </div>


    <div v-if="prop_solo_lectura">
      <div v-if="loading" class="w-6 h-6 mx-auto border-4 border-gray-300 border-t-blue-600  rounded-full animate-spin">
      </div>
    </div>
    <div>
      <!-- Nivel 1: Categorías -->

      <div v-for="categoria in this.categorias" :key="categoria.id" class="border rounded-lg     mt-3  ">

        <div v-if="centro" class="flex items-center justify-between px-6 py-4 mb-5   shadow-md" :class="borrador
          ? 'bg-gradient-to-r from-green-800 to-emerald-200 text-white'
          : 'bg-gradient-to-r from-indigo-800 to-blue-200 text-white'">
          <h2 class="   font-mono " :id="categoria.nombre.normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/\s+/g, '-')">
            {{ this.aa_consulta }} / {{ centro?.nombre }} / <strong>{{ categoria.nombre }} </strong>
          </h2>

        </div>

        <!-- Nivel 2: Tipos -->
        <div v-for="tipo in categoria.tipos" :key="tipo.id" class="mt-4">

          <h3 class="text-md  text-blue-700 mb-1 font-mono">{{ tipo.nombre }}</h3>

          <!-- Nivel 3: Cuentas -->
          <div v-for="cuenta in tipo.cuentas" :key="cuenta.id" class="ml-1">
            <!--  {{ cuenta }}  -->

            <CuentaPresupuestosSoloLectura v-if="prop_solo_lectura" :borrador="borrador" :propCuenta="cuenta"
              :propCentro="centro" :cuentaExpandida="cuentaExpandida" @toggleCuenta="toggleCuenta"
              @reloadTotPresup="reloadTotPresup"></CuentaPresupuestosSoloLectura>

            <CuentaPresupuestos v-else :borrador="borrador" :propCuenta="cuenta" :centro="centro"
              :cuentaExpandida="cuentaExpandida" :cuentaExpandidaBorrador="cuentaExpandidaBorrador"
              @toggleCuenta="toggleCuenta" @toggleCuentaBorrador="toggleCuentaBorrador"
              @reloadTotPresup="reloadTotPresup"></CuentaPresupuestos>


          </div>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
import api from "@/api/axios";
import { useCatPresup } from "@/composables/useCatPresup";
import CuentaPresupuestos from "./CuentaPresupuestos.vue";
import CuentaPresupuestosSoloLectura from "./CuentaPresupuestosSoloLectura.vue";
import TablaTotalesCentro from "./TablaTotalesCentro.vue"

export default {
  name: 'CentroCuentasMayorCero',
  props: {
    prop_obj_centro: {
      type: Object,

    },
    prop_categoria_id: {
      type: Number
    },
    prop_solo_lectura: {
      type: Boolean
    },
    prop_incluyeCero: {
      type: Boolean
    },
    centro_id: {
      type: Number
    },
    borrador: {
      type: Boolean
    }
  },
  data() {
    return {
      valor: '',
      listado: {},
      categorias: {},
      tipos: {},
      cuentaExpandida: [], // almacena IDs de cuentas abiertas
      cuentaExpandidaBorrador: [], // almacena IDs de cuentas abiertas
      accionModifPresup: 0,
      cuentamodif: 0,
      loading: false,
      total_presupuesto_centro: 0,
      presupuesto_categorias: [],
      date_time: "",
      categoria_id: 0,
      centro: {},
      responsable_firstname: '',
      responsable_lastname: '',
      incluyeCero: false,
      milisegpool: 0,
      aa_consulta:0
    }
  },
  methods: {

    polldata() {


      this.polling = setInterval(() => {
       this.categoriasAgrupadas();

      }, this.milisegpool);
    },
    async exportar_csv() {
      try {
        const data = {
          "centro_id": this.centro.id,
          responseType: "blob", // 👈 AQUÍ, no en headers
        };
        // solo trae presupuestos > 0
        const response = await api.post("api/v1/presupuestos/csv/", data, {
          headers: {
            "Content-Type": "application/json",
          }
        });

        const blob = new Blob([response.data], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = "presupuestos.csv";
        link.click();
      } catch (e) {
        console.log('error', e)
      }
    },

    toggleCuenta(id) {
      const i = this.cuentaExpandida.indexOf(id);
      if (i === -1) {

        this.cuentaExpandida.push(id);
        this.$store.dispatch("cuentaUpdVisible", { id: id, centro: this.centro.id, visible: true });
        // store showCta
      } else {
        //console.log(i)
        this.cuentaExpandida.splice(i, 1);
        this.$store.dispatch("cuentaUpdVisible", { id: id, centro: this.centro.id, visible: false });
      }
    },

    toggleCuentaBorrador(id) {
      const i = this.cuentaExpandidaBorrador.indexOf(id);
      if (i === -1) {
        console.log('hacer visible')
        this.cuentaExpandidaBorrador.push(id);
        this.$store.dispatch("cuentaUpdVisibleBorrador",
          { id: id, centro: this.centro.id, visible: true });
        // store showCta
      } else {
        //console.log(i)
        this.cuentaExpandidaBorrador.splice(i, 1);
        this.$store.dispatch("cuentaUpdVisibleBorrador",
          { id: id, centro: this.centro.id, visible: false });
      }
    },
    reloadTotPresup(valor) {

      console.log('actualiza:', valor)
      // this.categoriasAgrupadas()
    },

    async categoriasAgrupadas() {

      console.log('refrescando')

      this.loading = true;
      // recupera cuentas con presupuestos ingresados

      let presupuestos;
      try {

        let data = { "centro_id": this.centro.id };
        if (this.incluyeCero) {
          data["incluyeCero"] = this.incluyeCero;
        }

        if (this.categoria_id) {
          data.categoria_id = this.categoria_id
        }

        if (this.borrador) {
          data["borrador"] = this.borrador
        }
        // solo trae presupuestos > 0
        const response = await api.post("api/v1/presupuestos/centro/", data, {
          headers: {
            "Content-Type": "application/json",

          },
        });

        if (response?.status === 200) {

          presupuestos = response.data.presupuestos;

          /*  
          contiene el mismo centro_id
          en todos sus registros

          los cuenta_id no se repiten
           
          "presupuestos": 
          [
               {
                   "id": 5816,
                   "centro_id": 6,
                   "cuenta_id": 8,
                   "empresa_id": 1,
                   "aa": 2025,
                   "moneda_id": 1,
                   "total_presupuesto": "900000.00",
                   "total_gastos": "0.00"
               },
               
             v/s   this.$store.state.cuentas.cuentas
             [{
               "id":112,
               "codigo":"4.5.1030.80.44",
               "nombre":"Alarma",
               "tipo_cuenta":{
               "id":13,
               "nombre":"GTOS BASICOS CASAS E INSTALACIONES",
               "categoria_cuenta":{
                   "id":8,
                   "nombre":"GASTOS GENERALES"
               }
               }
             */

          this.total_presupuesto_centro = presupuestos.reduce(
            (acumulador, item) => {
              return acumulador + Number(item.total_presupuesto)
            }, 0)


          const cuentas = this.$store.state.cuentas.cuentas;
          const { getCatPresup } = useCatPresup()
          this.categorias = getCatPresup(presupuestos, cuentas);

          this.date_time = new Date().toISOString()
          // ordenar por atributo 'orden'
          this.categorias = Object.values(this.categorias).sort((a, b) =>
            (a.orden ?? Infinity) -
            (b.orden ?? Infinity)
          );
          this.loading = false;

          /*
       [{
         "id": 1,
         "nombre": "GASTOS DEL PERSONAL",
         "tipos": [
             {
                 "id": 1,
                 "nombre": "GASTOS DEL PERSONAL",
                 "cuentas": [
                     {
                         "id": 5,
                         "cod": "4510301005",
                         "nomcta": "Alimentacion del personal",
                         "total_presupuesto": "4507981.00",
                         "total_gastos": "0.00",
                         "saldo": 4507981
                     },
                     {
                         "id": 6,
                         "cod": "4510301006",
                         "nomcta": "Beneficios al Personal",
                         "total_presupuesto": "900020.00",
                         "total_gastos": "0.00",
                         "saldo": 900020
                     } 
                         
                     
                     
                */


        }

        this.presupuesto_categorias = this.categorias.map(grupo => ({
          nombre: grupo.nombre,
          total_presupuesto: grupo.tipos.flatMap(t => t.cuentas).reduce((acc, c) => acc + Number(c.total_presupuesto), 0)
        }));



      } catch (e) {
        console.error("Credenciales inválidas ❌", e);
      }




    },


  },
  mounted() {

    this.aa_consulta = this.$store.state.auth.userLogin.año
    if (this.borrador) {
      this.aa_consulta = this.$store.state.auth.userLogin.año_borrador
    }


    this.milisegpool = this.$store.state.auth.userLogin.is_admin ?
      10000 : 300000;

    this.incluyeCero = this.prop_incluyeCero
    this.centro = this.prop_obj_centro;
    this.categoria_id = this.prop_categoria_id;
    this.responsable_firstname = this.centro?.usuarios[0]?.first_name
    this.responsable_lastname = this.centro?.usuarios[0]?.last_name
    //let obj = this.$store.state.centrocuentas.visibilidad;
    let obj = []
    if (this.centro != null) {
      const filtrados = obj.filter(item => item.centro === this.centro.id);
      filtrados.forEach(element => {

        const id = element.id;

        this.cuentaExpandida.push(id);
        this.cuentaExpandidaBorrador.push(id);

      });

      this.categoriasAgrupadas()
     
      if (this.prop_solo_lectura !== true) {
        this.polldata();
      }

    }
  },
  components: {

    CuentaPresupuestos,
    TablaTotalesCentro,
    CuentaPresupuestosSoloLectura,

  },
  watch: {

    prop_categoria_id: function (value) {
      console.log('watch prop_categoria_id', value)
      this.categoria_id = value
      this.categoriasAgrupadas()

    },
    prop_obj_centro: function (value) {
      console.log('watch prop_obj_centro', value)
      this.centro = value;
      this.categoriasAgrupadas()
    },
    prop_incluyeCero: function (value) {
      console.log('watch prop_incluyeCero', value)
      this.incluyeCero = value;
    }

  },
  beforeUnmount() {
    clearInterval(this.polling);
  },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>